<div class="reviews-outer" [formGroup]="terrainForm">
  <h2 class="trinidad-bold">What type of terrain is at this location?</h2>
  <p class="wizard-paragraph _12px">
    Let us know the type(s) of terrain available at this location. Please be as accurate as possible.
  </p>
  <div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="backyard"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Backyard</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="backyard"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="beach"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Beach</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="beach"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="brewery"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Brewery</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="brewery"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="canyon"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Canyon</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="canyon"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="coastal"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Coastal</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="coastal"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="curbside"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Curbside</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="curbside"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="desert"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Desert</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="desert"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="distillery"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Distillery</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="distillery"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="driveway"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Driveway</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="driveway"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="farm"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Farmland</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="farmland"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="forest"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Forest</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="forest"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="hotSpring"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Hot Springs</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="hotSprings"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="lake"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Lake</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="lake"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="mountains"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Mountains</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="mountains"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="orchard"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Orchard</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="orchard"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="plain"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Plain / Prairie</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="plains"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="stream"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">River / Stream</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="river"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="suburban"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Suburban</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="suburban"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="urban"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Urban</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="urban"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="waterfall"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Waterfall</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="waterfall"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="wetlands"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Wetlands</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="wetlands"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="winery"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Winery</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="winery"></curbnturf-rating-availability-toggle>
    </div>
  </div>
  <div class="button-wrapper">
    <a role="button" class="button trinidad center w-button" (click)="onContinue()">Continue</a>
  </div>
  <div class="skip" *ngIf="!appContext">
    <a role="button" (click)="onSkip()">Skip</a>
  </div>
</div>
